import axios from 'axios';
import setAuthToken from '../utils/setAuthToken';
import jwt_decode from 'jwt-decode';

import { GET_ERRORS, SET_CURRENT_USER, CLEAR_ERRORS } from './types';

// Register User
export const registerUser = (userData, history) => dispatch => {
  dispatch(clearErrors());
  axios
    .post('/api/users/register', userData)
    .then(res => history.push('/login'))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Upload profile pic
export const uploadProfilePic = (userData, history) => dispatch => {
  dispatch(clearErrors());
  axios
    .post('/api/users/avatar', userData)
    .then(res => history.push('/dashboard'))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Login - Get User Token
export const loginUser = userData => dispatch => {
  dispatch(clearErrors());
  axios
    .post('/api/users/login', userData)
    .then(res => {
      // Save to local storage
      const { token } = res.data;
      // set to local storage
      localStorage.setItem('jwtToken', token);
      // Set token to Auth header
      setAuthToken(token);
      // decode token for user data
      const decoded = jwt_decode(token);
      // Set current user
      dispatch(setCurrentUser(decoded));
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// set logged user
export const setCurrentUser = decoded => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded
  };
};

// Log user out
export const logoutUser = () => dispatch => {
  // Remove token from localstorage
  localStorage.removeItem('jwtToken');
  // Remove Auth header for future requests
  setAuthToken(false);
  // Set current to {} which will set isAuthenticated to false
  dispatch(setCurrentUser({}));

  // Redirect to login
  window.location.href = '/';
};

// Request Reset password for User
export const resetPass = (userData, history) => dispatch => {
  dispatch(clearErrors());
  axios
    .post('/api/users/reset-pass', userData)
    .then(res => history.push('/'))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Create New Reset password for User
export const createNewPass = (userData, history) => dispatch => {
  dispatch(clearErrors());
  axios
    .put(`/api/users/create-new-pass/${userData.token}`, userData)
    .then(res => history.push('/login'))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Clear Errors
export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS
  };
};
